webpackJsonp([4],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(43);
module.exports = __webpack_require__(44);


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

$(function () {
    hasFollow();
});

function hasFollow() {
    if (!islogin()) {
        return;
    }

    var id = $('.follow-btn').data('id');
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/users/followed/' + id,
        data: {},
        contentType: 'application/json',
        success: function (result) {
            for (var key in result) {
                if (key == id) {
                    if (result[id].followed) {
                        $('.follow-btn').text('取消关注');
                    } else {
                        $('.follow-btn').text('+关注');
                    }
                    break;
                }
            }
        },
        error: function (data) {
            console.log(data.responseText);
        }
    });
}

function islogin() {
    if ($('.top .top-user').data('info')) {
        return true;
    }

    return false;
}

$('.follow-btn').click(function () {
    if (!islogin()) {
        showLogin();
        return;
    }

    var id = $('.follow-btn').data('id');
    var isfollowed = $('.follow-btn').text() != '+关注';
    var data={
        follow: !isfollowed
    };
    $.ajax({
        type: 'post',
        async: false,
        url: ROOT + '/users/follow/' + id,
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (isfollowed) {
                $('.follow-btn').text('+关注');
            } else {
                $('.follow-btn').text('取消关注');
            }
        },
        error: function (data) {
            alert(data.responseText);
        }
    });
});

$('.like-btn').click(function () {
    if (!islogin()) {
        showLogin();
        return;
    }

    var id = $('.like-btn').data('id');
    var isLike = $('.like-btn').text() == '为Ta点赞';
    if (isLike) {
        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/content/' + id + '/like',
            data: {},
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                $('.like-btn').text('取消点赞');
            },
            error: function (data) {
                alert(data.responseText);
            }
        });
    } else {
        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/content/' + id + '/cancel-attitude',
            data: {},
            contentType: 'application/json',
            success: function (result) {
                $('.like-btn').text('为Ta点赞');
            },
            error: function (data) {
                alert(data.responseText);
            }
        });
    }
});

/***/ })

},[42]);


// WEBPACK FOOTER //
// js/toproom5b480e.js